/*
  Carrito flotante de Binco (03/11/2026).

  Agrega al cajón del carrito, sin tocar los archivos del tema:
    - título "Tu carrito"
    - cartel "¡Obtuviste el Envío Gratis!" con una barra completa (el envío es gratis en todo el país)
    - fila "Ahorrás" con lo que se ahorra en total frente al precio tachado
    - "Subtotal" en lugar de "Total estimado"
    - botón "FINALIZAR PEDIDO"
    - banda con los medios de pago debajo del botón

  El cajón se vuelve a dibujar cada vez que cambia el carrito, así que todo se aplica de nuevo
  con un MutationObserver; cada paso revisa si ya está hecho para no repetirse.
*/
(() => {
  const PAY = window.BINCO_PAYBAND || '';
  const cache = new Map();
  let lastSig = '';
  let savings = 0;
  let busy = false;

  const fmt = (cents) => `$${Math.round(cents / 100).toLocaleString('es-UY')}`;

  const loadProduct = (handle) => {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(`/products/${handle}.js`)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      );
    }
    return cache.get(handle);
  };

  const computeSavings = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const sig = cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');
      if (sig === lastSig) return;
      let total = 0;
      for (const item of cart.items) {
        const product = await loadProduct(item.handle);
        const variant = product?.variants?.find((v) => v.id === item.variant_id);
        if (variant && variant.compare_at_price > item.final_price) {
          total += (variant.compare_at_price - item.final_price) * item.quantity;
        }
      }
      lastSig = sig;
      savings = total;
    } catch (e) {
      /* sin ahorro si algo falla */
    } finally {
      busy = false;
      apply();
    }
  };

  const setText = (el, from, to) => {
    if (!el) return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.trim() === from) {
        n.nodeValue = n.nodeValue.replace(from, to);
        return;
      }
    }
  };

  const truck =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h14v10H1z"/><path d="M15 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';

  // Cajón (si el tema lo usa) y página del carrito: comparten el resumen y el botón de pagar.
  const applyTo = (root, itemsSel, titleSel) => {
    setText(root.querySelector(titleSel), 'Carrito', 'Tu carrito');

    const content = root.querySelector(itemsSel);
    if (!content) return; // carrito vacío

    // Cartel de envío gratis, arriba de los productos
    if (!root.querySelector('.binco-cart-ship')) {
      const el = document.createElement('div');
      el.className = 'binco-cart-ship';
      el.innerHTML =
        '<p class="binco-cart-ship__text">¡Obtuviste el Envío Gratis! 🎉</p>' +
        '<div class="binco-cart-ship__bar"><span class="binco-cart-ship__fill"></span>' +
        `<span class="binco-cart-ship__truck">${truck}</span></div>`;
      content.before(el);
    }

    const totals = root.querySelector('.cart-totals');
    if (totals) {
      setText(totals.querySelector('.cart-totals__total-label'), 'Total estimado', 'Subtotal');

      let row = totals.querySelector('.binco-cart-save');
      if (savings > 0) {
        if (!row) {
          row = document.createElement('div');
          row.className = 'binco-cart-save';
          const total = totals.querySelector('.cart-totals__total');
          (total || totals).before(row);
        }
        const html = `<span>Ahorrás</span><span>-${fmt(savings)}</span>`;
        if (row.innerHTML !== html) row.innerHTML = html;
      } else if (row) {
        row.remove();
      }
    }

    const btn = root.querySelector('.cart__checkout-button');
    if (btn) {
      setText(btn, 'Pagar', 'FINALIZAR PEDIDO');
      setText(btn, 'Finalizar compra', 'FINALIZAR PEDIDO');

      if (PAY && !root.querySelector('.binco-cart-pay')) {
        const img = document.createElement('img');
        img.className = 'binco-cart-pay';
        img.src = PAY;
        img.alt = 'Medios de pago: Visa, Mastercard, OCA, Mercado Pago';
        img.loading = 'lazy';
        const host = btn.closest('.cart-actions') || btn.parentElement;
        host.after(img);
      }
    }
  };

  const apply = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer) applyTo(drawer, '.cart-drawer__content', '#cart-drawer-heading, .theme-drawer__title');
    const page = document.querySelector('.cart-page');
    if (page) applyTo(page, '.cart-page__items', '.cart-title h1');
  };

  let queued = false;
  const refresh = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
      if (document.querySelector('#cart-drawer .cart-drawer__content, .cart-page__items')) computeSavings();
    });
  };

  const init = () => {
    refresh();
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
